export const types = {
    SET_GET_TRANSACTIONS_LIST: '[TRANSACTION] SET GET TRANSACTIONS LIST',
    SET_GET_TRANSACTIONS_BY_ID: '[TRANSACTION] SET GET TRANSACTIONS BY ID',
}